import { render, staticRenderFns } from "./InventoryLayout.vue?vue&type=template&id=068ca16e&"
import script from "./InventoryLayout.vue?vue&type=script&lang=js&"
export * from "./InventoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports